export type PlanDisplayConfig = {
  order: number;
  showPlan: boolean;
};

export const PLAN_DISPLAY: Record<string, PlanDisplayConfig> = {
  'free-tier': { order: 0, showPlan: false },
  starter: { order: 1, showPlan: true },
  business: { order: 2, showPlan: true },
  pro: { order: 3, showPlan: false },
  'power-pro': { order: 4, showPlan: false },
  'team-plan': { order: 5, showPlan: false },
  enterprise: { order: 6, showPlan: true },
};

export const isEnterprisePlanCode = (code?: string) =>
  !!code && code.toLowerCase().startsWith('enterprise');

export const getPlanDisplay = (code?: string): PlanDisplayConfig | undefined => {
  if (!code) return undefined;
  const key = code.toLowerCase();
  return PLAN_DISPLAY[key] ?? (isEnterprisePlanCode(key) ? PLAN_DISPLAY.enterprise : undefined);
};

export const FALLBACK_ENTERPRISE_PLAN = {
  planId: 'enterprise-fallback',
  code: 'enterprise',
  displayName: 'Enterprise',
  description: 'Higher usage across chat, voice, and integrations.',
  familyCode: 'klax',
  familyRank: 6,
  usageInterval: 'month',
  usageIntervalCount: 1,
  quantityDiscountCombinationPolicy: 'none',
  organizationId: null,
  featuresJson: null,
  trialDays: null,
  trialRequiresPaymentMethod: false,
  version: 1,
  hasSubscribers: false,
  prices: [],
  entitlements: [],
  meters: [],
  quantityItems: [],
  trialGrants: [],
};

export const visibleSubscriptionPlans = <T extends { code: string }>(plans: T[]): T[] => {
  const visible = plans.filter((plan) => getPlanDisplay(plan.code)?.showPlan);
  if (!visible.some((plan) => isEnterprisePlanCode(plan.code))) {
    visible.push(FALLBACK_ENTERPRISE_PLAN as unknown as T);
  }
  return visible.sort(
    (a, b) => (getPlanDisplay(a.code)?.order ?? 0) - (getPlanDisplay(b.code)?.order ?? 0)
  );
};
